module.exports = __webpack_public_path__ + "img/404-ilustration.739536b1.svg";